import React from 'react';
import TextComponent from '../TextComponent';

const LengthText = (props) => {
  const name = 'carrier_length';
  const defaultChange = e => props.onChangeParameter(name, e.target.value);

  const onChange = props.onChange || defaultChange;
  return (
    <TextComponent
      label={props.label}
      name={name}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      groupName={props.groupName} >
      {props.children}
    </TextComponent>
  );
};

LengthText.defaultProps = {
  required: true,
  label: 'Carrier Length ',
};

export default LengthText;
